import { createContext, useReducer, Dispatch } from 'react';

import { RecaptchaLibToken } from '../types/types';

interface RecaptchaLibState {
  scoreBasedSiteKey?: RecaptchaLibToken,
  checkboxFallbackSiteKey?: RecaptchaLibToken,
  loaded: boolean,
  scoreBasedToken?: RecaptchaLibToken,
  checkboxFallbackToken?: RecaptchaLibToken,
}

const initialState: RecaptchaLibState = {
  loaded: false,
};

export const RecaptchaLibContext = createContext<RecaptchaLibState>(initialState);

function recaptchaLibReducer(state: RecaptchaLibState, action: Partial<RecaptchaLibState>) {
  return {
    ...state,
    ...action,
  };
}

export const RecaptchaLibDispatchContext = createContext<Dispatch<Partial<RecaptchaLibState>>>(() => {});

export const useRecaptchaLibReducer = () => (
  useReducer(
    recaptchaLibReducer,
    initialState,
  )
);
